// this is perhaps the dumbest thing I have ever had to do.
// Since network error handling is done BEFORE making it back up to the component that made the call, we can't propagate the error back properly without rewriting the whole app.
// So here we are. With a god damn global variable that is just passed around to comunicate that the error is gonna be handled by something else so don't worry about it.
// I'm sorry.
//
// sidenote: I hate how in javascript, not only does this work, but it works well. This should be not only discouraged, but completely impossible.
// it has no safety rails, it just lets you do stupid things, and it makes the stupid things really easy to do and work kinda well (until they don't)
var bypassError = false;
